<template>
 <div id="user-app">
   <!-- 用户名:{{data.msg}}
   <button @click="get_user">获取用户</button> -->
   <TopRightCmp />
   
 </div> 
 
</template>

<script>
  // import workhours from './workroomscreen/workhours.vue'  
  // import Qangsum from './workroomscreen/Qangsum';
  // import TopRightCmp from './workroomscreen/Chartpie'
  // import TopRightCmp from './workroomscreen/Qangsum' 
  // import TopRightCmp from './workroomscreen/Salesum' 
  // import TopRightCmp from './workroomscreen/TopCol' 
  // import TopRightCmp from './workroomscreen/workhours' 
  // import {useRoute} from 'vue-router';
  // const route = useRoute()
  // import TopRightCmp from './workroomscreen/myleftviewa' 

  import TopRightCmp from './bigscreenSales/components/ReceivingOrders' 


  var data = {
   msg :'',
  };  
  

    export default {
        name: "User",
        components: {
          // workhours,
          // Qangsum,
          TopRightCmp
        },
      data(){
        return{
           data
          };
        },
       methods: {
        get_user(){
            this.axios({
                method: 'post',
                params: {
                  compid: 8888920
                },
                url:'http://bsmtp:8080/admin.php/index/aa'
                // url:'/api/index.php/index/index/'
                // '/api/indexx.php/index/inex/aa',
            }).then((Response)=>{
                data.msg=Response.data;
            }).catch(function(error){
                console.log(error);
            })
            
        }
    },
    created() {
      

    },
    }
   
</script>

<style scoped>
#user-app{
   top: 0%;
   height: 100%;
   width: 100%;
   position: absolute;
   border: 3px solid coral;
   background-color: black;
}
</style>


// WEBPACK FOOTER //
// src/views/User.vue